export default "__VITE_ASSET__BWbKY1Sv__"